var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { Dependencies } from "~/core/decorator";
import { TurnRecordService } from "~/services/domain-service/turn-record.service";
import { PageService } from "~/utils/page.service";
var TurnRecord = /** @class */ (function (_super) {
    __extends(TurnRecord, _super);
    function TurnRecord() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.queryModel = {
            turnData: [],
            triggerAction: "",
            caseType: "",
            overduePeriod: "",
            name: ""
        };
        return _this;
    }
    TurnRecord.prototype.query = function () {
        var dataForm = this.$refs.form;
        dataForm.resetForm();
        this.refreshData();
    };
    TurnRecord.prototype.refreshData = function () {
        var _this = this;
        this.turnRecordService
            .findTurnRecordDetailPage(this.caseNumber, this.queryModel, this.page)
            .subscribe(function (data) { return (_this.dataSet = data); });
    };
    __decorate([
        Prop({ required: true })
    ], TurnRecord.prototype, "caseNumber", void 0);
    __decorate([
        Prop()
    ], TurnRecord.prototype, "open", void 0);
    __decorate([
        Dependencies(TurnRecordService)
    ], TurnRecord.prototype, "turnRecordService", void 0);
    __decorate([
        Dependencies(PageService)
    ], TurnRecord.prototype, "page", void 0);
    TurnRecord = __decorate([
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox
            }
        })
    ], TurnRecord);
    return TurnRecord;
}(Vue));
export default TurnRecord;
